export default __webpack_public_path__ + "media/icons/body-icon-active-62148c06.png";